import { IdentifiableDto } from "./identifiable.dto";

export class AddMatchedLeadsProductHiringAreaDto extends IdentifiableDto {
    radius: number;
    lat: number;
    lng: number;
}